module.exports = __webpack_public_path__ + "img/caseimeivivosmall.61426e54.png";